// extracted by mini-css-extract-plugin
module.exports = {"buttonRoot":"FavoriteButton_buttonRoot__45huT","iconButton":"FavoriteButton_iconButton__VnNWJ"};